export default __webpack_public_path__ + "static/media/checked.d6ded603.svg";